/**
 * ADMIN MODULE
 * Internal ops layer — platform_admins only.
 * Never import this from any product module.
 *
 * Public entry point. Routes register under the 'super_admin' role; the app root
 * gates them with RequireSuperAdmin (auth + platform_admins check). RLS remains
 * the hard boundary for all admin data.
 */

import AdminDashboard from "./routes/AdminDashboard.jsx";
import AgentsView from "./routes/AgentsView.jsx";
import LinkedInFlywheelView from "./routes/LinkedInFlywheelView.jsx";
import SeoRankView from "./routes/SeoRankView.jsx";
import SupportTicketsView from "./routes/SupportTicketsView.jsx";
import EmailTemplateView from "./routes/EmailTemplateView.jsx";
import EmailNurtureView from "./routes/EmailNurtureView.jsx";
import EmailReferenceView from "./routes/EmailReferenceView.jsx";
import AdminTeamView from "./routes/AdminTeamView.jsx";
import AdminModulesView from "./routes/AdminModulesView.jsx";
import HarborRidgeDemoSite from "./routes/HarborRidgeDemoSite.jsx";

export { RequireSuperAdmin } from "./middleware.jsx";

export const adminRoutes = [
  { path: "/admin", component: AdminDashboard },
  { path: "/admin/agents", component: AgentsView },
  { path: "/admin/linkedin", component: LinkedInFlywheelView },
  { path: "/admin/seo", component: SeoRankView },
  { path: "/admin/tickets", component: SupportTicketsView },
  { path: "/admin/email", component: EmailTemplateView },
  { path: "/admin/nurture", component: EmailNurtureView },
  { path: "/admin/email-reference", component: EmailReferenceView },
  { path: "/admin/team", component: AdminTeamView },
  { path: "/admin/modules", component: AdminModulesView },
  // A stand-in for a customer's own website, used to demo the POS ordering
  // embed live and to capture it for the marketing site. Staff-only like
  // everything else here, which is what keeps a page dressed as a winery off
  // the public internet. Top-level path because it is pretending NOT to be part
  // of an admin console — App.jsx also suppresses the Brand Command header for
  // it, or the illusion breaks the moment you screenshot it.
  { path: "/harbor-ridge", component: HarborRidgeDemoSite },
];
